import React, { useEffect, useState } from 'react';
import styles from "./WholesalerVariationTable.module.scss";
import { FiTrash2 } from "react-icons/fi";
import { Button, Input } from 'reactstrap';
import DynamicTable from '../../common/DynamicTable/DynamicTable';

const WholesalerVariationTable = ({ combinations }) => {
    const [tableData, setTableData] = useState([]);

    // Prepare table data from combinations
    useEffect(() => {
        const initialData = combinations.map((combination, index) => ({
            id: index,
            variations: combination,
            sku: "",
            sellingPrice: "",
            buyingPrice: "",
            discountedPrice: "",
            quantity: "",
            bulkRanges: []
        }));
        setTableData(initialData);
    }, [combinations]);

    // Update specific row or field
    const handleInputChange = (index, field, value) => {
        const updatedData = [...tableData];
        updatedData[index][field] = value;
        setTableData(updatedData);
    };

    // Add a new range for bulk pricing
    const handleAddRange = (rowIndex) => {
        const updatedData = [...tableData];
        updatedData[rowIndex].bulkRanges.push({ min: "", max: "", price: "" });
        setTableData(updatedData);
    };

    // Update range values
    const handleRangeChange = (rowIndex, rangeIndex, field, value) => {
        const updatedData = [...tableData];
        updatedData[rowIndex].bulkRanges[rangeIndex][field] = value;
        setTableData(updatedData);
    };

    // Delete a specific row
    const handleDeleteRow = (index) => {
        setTableData((prev) => prev.filter((_, i) => i !== index));
    };

    // const columns = [
    //     {
    //         name: "Variations",
    //         cell: (row) => (
    //             <div className={styles.variationsDataRow}>
    //                 {Object.keys(row.variations).map((key) => (
    //                     <div key={key}>
    //                         <span>{key}</span>: {row.variations[key]}<br />
    //                     </div>
    //                 ))}
    //             </div>
    //         ),
    //         sortable: false,
    //         wrap: true,
    //         minWidth: '150px',
    //     },
    //     {
    //         name: "SKU",
    //         cell: (row, index) => (
    //             <>
    //                 <Input
    //                     type="text"
    //                     placeholder="Add SKU"
    //                     value={row.sku}
    //                     onChange={(e) =>
    //                         handleInputChange(index, "sku", e.target.value)
    //                     }
    //                 />
    //                 {/* <div color="link" className={styles.suggestionText}>
    //                     <GiPanda size={18} className={styles.pandaImg} />
    //                     Al-generate
    //                 </div> */}
    //             </>
    //         ),
    //         minWidth: '180px',
    //     },
    //     {
    //         name: "Selling Price | Buying Price | Discounted Price",
    //         cell: (row, index) => (
    //             <div className={styles.pricesRow}>
    //                 <div className={styles.priceInputGroup}>
    //                     <Input
    //                         type="text"
    //                         placeholder="S.P."
    //                         value={row.sellingPrice}
    //                         onChange={(e) =>
    //                             handleInputChange(index, "sellingPrice", e.target.value)
    //                         }
    //                         className={styles.priceInput}
    //                     />
    //                     <Input
    //                         type="text"
    //                         placeholder="B.P."
    //                         value={row.buyingPrice}
    //                         onChange={(e) =>
    //                             handleInputChange(index, "buyingPrice", e.target.value)
    //                         }
    //                         className={styles.buyingPriceInput}
    //                     />
    //                     <Input
    //                         type="text"
    //                         placeholder="D.P."
    //                         value={row.discountedPrice}
    //                         onChange={(e) =>
    //                             handleInputChange(index, "discountedPrice", e.target.value)
    //                         }
    //                         className={styles.discountedPriceInput}
    //                     />
    //                 </div>
    //                 {/* <div color="link" className={styles.suggestionText}>
    //                     <GiPanda size={18} className={styles.pandaImg} />
    //                     $15.00/ $13.00
    //                 </div> */}
    //             </div>
    //         ),
    //         minWidth: '340px',
    //     },
    //     {
    //         name: "Quantity",
    //         cell: (row, index) => (
    //             <Input
    //                 type="text"
    //                 placeholder="Add quantity"
    //                 value={row.quantity}
    //                 onChange={(e) =>
    //                     handleInputChange(index, "quantity", e.target.value)
    //                 }
    //             />
    //         ),
    //         minWidth: '150px',
    //     },
    //     {
    //         name: "Bulk Ranges (Min-Max Units | Price)",
    //         cell: (row, rowIndex) => (
    //             <div className={styles.bulkRangePriceRow}>
    //                 {row.bulkRanges?.map((range, rangeIndex) => (
    //                     <div key={rangeIndex} className={styles.rangeInputRow}>
    //                         <Input
    //                             type="number"
    //                             placeholder="Min Units"
    //                             value={range.min}
    //                             onChange={(e) =>
    //                                 handleRangeChange(rowIndex, rangeIndex, "min", e.target.value)
    //                             }
    //                         />
    //                         <Input
    //                             type="number"
    //                             placeholder="Max Units"
    //                             value={range.max}
    //                             onChange={(e) =>
    //                                 handleRangeChange(rowIndex, rangeIndex, "max", e.target.value)
    //                             }
    //                         />
    //                         <Input
    //                             type="number"
    //                             placeholder="Price"
    //                             value={range.price}
    //                             onChange={(e) =>
    //                                 handleRangeChange(rowIndex, rangeIndex, "price", e.target.value)
    //                             }
    //                         />
    //                     </div>
    //                 ))}
    //                 <Button
    //                     size="sm"
    //                     color="primary"
    //                     onClick={() => handleAddRange(rowIndex)}
    //                 >
    //                     Add Range
    //                 </Button>
    //             </div>
    //         ),
    //         minWidth: '300px',
    //     },
    //     {
    //         name: "Bulk Ranges (Min-Max Units | Price)",
    //         cell: (row, index) => (
    //             <div className={styles.bulkRanges}>
    //                 {row.bulkRanges?.map((range, idx) => (
    //                     <div key={idx} className={styles.rangeRow}>
    //                         <span>{range.min}-{range.max} Units: ${range.price}</span>
    //                     </div>
    //                 ))}
    //             </div>
    //         ),
    //         minWidth: '300px',
    //     },
    // ];

    // Columns definition
    const columns = [
        {
            name: "Variations",
            cell: (row) => (
                <div className={styles.variationsDataRow}>
                    {Object.entries(row.variations).map(([key, value]) => (
                        <div key={key}>
                            <span>{key}:</span> {value}
                        </div>
                    ))}
                </div>
            ),
            minWidth: '150px',
        },
        {
            name: "SKU",
            cell: (row, index) => (
                <div>
                    <Input
                        type="text"
                        placeholder="Add SKU"
                        value={row.sku}
                        onChange={(e) => handleInputChange(index, "sku", e.target.value)}
                    />
                </div>
            ),
            minWidth: '180px',
        },
        {
            name: "Selling Price | Buying Price | Discounted Price",
            cell: (row, index) => (
                <div className={styles.pricesRow}>
                    {["sellingPrice", "buyingPrice", "discountedPrice"].map((field) => {
                        const placeholderMap = {
                            sellingPrice: "S.P.",
                            buyingPrice: "B.P.",
                            discountedPrice: "D.P.",
                        };
                        return (
                            <Input
                                key={field}
                                type="text"
                                placeholder={placeholderMap[field]} // Use the mapping for placeholders
                                value={row[field]}
                                onChange={(e) => handleInputChange(index, field, e.target.value)}
                                className={styles.priceInput}
                            />
                        );
                    })}
                </div>
            ),
            minWidth: '340px',
        },
        {
            name: "Quantity",
            cell: (row, index) => (
                <Input
                    type="text"
                    placeholder="Add quantity"
                    value={row.quantity}
                    onChange={(e) => handleInputChange(index, "quantity", e.target.value)}
                />
            ),
            minWidth: '150px',
        },
        {
            name: "Bulk Units Range (Min-Max | Price)",
            cell: (row, rowIndex) => (
                <div className={styles.bulkRangePriceRow}>
                    {row.bulkRanges.map((range, rangeIndex) => (
                        <div key={rangeIndex} className={styles.rangeInputRow}>
                            {["min", "max", "price"].map((field) => (
                                <Input
                                    key={field}
                                    type="number"
                                    placeholder={field === "price" ? "Price" : `${field.charAt(0).toUpperCase() + field.slice(1)} Units`}
                                    value={range[field]}
                                    onChange={(e) =>
                                        handleRangeChange(rowIndex, rangeIndex, field, e.target.value)
                                    }
                                />
                            ))}
                        </div>
                    ))}
                    <Button size="sm" color="info" className={styles.rangeBtn} onClick={() => handleAddRange(rowIndex)}>
                        Add Range
                    </Button>
                </div>
            ),
            minWidth: '340px',
        },
    ];

    return (
        <div>
            {combinations.length > 0 && (
                <div className={styles.combinationContainer}>
                    <h5 className={styles.combinationTitle}>Variation Combinations</h5>
                    <DynamicTable
                        columns={columns}
                        data={tableData}
                        onRowDelete={handleDeleteRow}
                        customStyles={customStyles}
                        isPagination={true}
                    />
                </div>
            )}
        </div>
    );
};

// Custom table styles
const customStyles = {
    table: {
        style: { border: '1px solid #D9D9D9' },
    },
    headRow: {
        style: { backgroundColor: '#F2F2F2', borderBottom: 'none' },
    },
    rows: {
        style: { borderBottom: 'none !important' },
    },
    headCells: {
        style: {
            borderBottom: 'none',
            padding: '8px',
            fontSize: '14px',
            fontWeight: '400',
            color: '#1A2425',
            justifyContent: 'center',
        },
    },
    cells: {
        style: {
            borderBottom: 'none',
            padding: '20px 8px',
            fontSize: '14px',
            fontWeight: '400',
            color: '#1A2425',
        },
    },
};

export default WholesalerVariationTable;